// [
// 	{
// 		statusCode: 'unfulfilled',
// 		statusName: 'Unfulfilled',
// 		statusOrder: 1,
// 		id: 1,
// 	},
// 	{
// 		statusCode: 's_requested',
// 		statusName: 'Shipment Requested',
// 		statusOrder: 2,
// 		id: 2,
// 	},
// 	{
// 		statusCode: 'payment_expected',
// 		statusName: 'Awaiting payment',
// 		statusOrder: 3,
// 		id: 9,
// 	},
// 	{
// 		statusCode: 'waiting_proforma',
// 		statusName: 'Awaiting Signing',
// 		statusOrder: 4,
// 		id: 6,
// 	},
// 	{
// 		statusCode: 'proforma_signed',
// 		statusName: 'Proforma Signed',
// 		statusOrder: 5,
// 		id: 3,
// 	},
// 	{
// 		statusCode: 'l_generated',
// 		statusName: 'Label Printed',
// 		statusOrder: 6,
// 		id: 5,
// 	},
// 	{
// 		statusCode: 'rm_recieved',
// 		statusName: 'Received by Royal Mail',
// 		statusOrder: 7,
// 		id: 10,
// 	},
// 	{
// 		statusCode: 'omniva_recieved',
// 		statusName: 'Delivered to EU warehouse',
// 		statusOrder: 7,
// 		id: 11,
// 	},
// 	{
// 		statusCode: 'customs_start',
// 		statusName: 'Handling by Customs started',
// 		statusOrder: 8,
// 		id: 7,
// 	},
// 	{
// 		statusCode: 'cleared',
// 		statusName: 'Released by Customs',
// 		statusOrder: 9,
// 		id: 4,
// 	},
// 	{
// 		statusCode: 'omniva_printed',
// 		statusName: 'Delivery to end customer accepted',
// 		statusOrder: 10,
// 		id: 8,
// 	},
// 	{
// 		statusCode: 'omniva_delivered',
// 		statusName: 'Delivered to end customer',
// 		statusOrder: 11,
// 		id: 12,
// 	},
// ];

export enum SwisspostShippingStatus {
	UNFULFILLED = 'Unfulfilled',
	DELIVERY_REQUESTED = 'Delivery Requested',
	PROFORMA_SIGNED = 'Proforma signed',
	UNPAID = 'Taxes & Duties Invoiced',
	PAID = 'Taxes & Duties Paid',
	CLEARED = 'Customs Cleared',
	LABEL_PRINTED = 'Label Printed',
	WAITING_PROFORMA = 'Awaiting Signing',
}
